import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { default as english } from '../locales/en/translation.json';
import { default as settingsTranslations } from '../locales/en/settings.json';
import { default as settingsTranslationsOld } from '../locales/en/settings_old.json';
import { default as removedTranslations } from '../locales/en/translation_old.json';
const fallbackLng = 'en';
const availableLanguages = [
    'en',
    'fr',
    'de',
    'ar',
    //'he',
    'it',
    //'fa',
    'pl',
    'pt',
    //'ro',
    'tr',
    'es',
    'id',
    'ur'
    //'cs',
    //'no',
    //'nl',
    //'ph',
    //'el',
    //'ru',
    //'vi',
    //'sk',
    //'bg',
    //'sl',
    //'th',
    //'hu',
    //'jp',
];


export const languagesWithRtl = [/** hebrew */ 'he', 'ar', 'ur'];

export const languagesObject = [
    { value: 'ar', label: 'Arabic' },
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'French' },
    { value: 'de', label: 'German' },
    //{ value: 'he', label: 'Hebrew' },
    { value: 'it', label: 'Italian' },
    { value: 'id', label: 'Indonesian' },
    //{ value: 'fa', label: 'Persian' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese' },
    //{ value: 'ro', label: 'Romanian' },
    { value: 'tr', label: 'Turkish' },
    { value: 'es', label: 'Spanish' },
    { value: 'ur', label: 'Urdu' },
    //{ value: 'cs', label: 'Czech' },
    // { value: 'no', label: 'Norwegian' },
    //{ value: 'nl', label: 'Dutch' },
    // {value:'ph', label:''},
    // { value: 'el', label: 'Greek' },
    //{ value: 'ru', label: 'Russian' },
    //{ value: 'vi', label: 'Vietnamese' },
    // { value: 'sk', label: 'Slovak' },
    // { value: 'bg', label: 'Bulgarian' },
    // { value: 'sl', label: 'Slovenian' },
    // { value: 'th', label: 'Thai' },
    // { value: 'hu', label: 'Hungarian' },
    // { value: 'jp', label: 'Japanese' },
];
/*
const getLocale = (): string => {
    if (session.has('locale')) {
        return session.get('locale');
    }

    if (local.has('locale')) {
        return local.get('locale');
    }

    return 'en';
};
*/

const translationInstance = i18n.createInstance();

translationInstance
    .use(XHR)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        detection: {
            order: ['querystring', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain', 'cookie'],
            lookupQuerystring: 'lng',
            lookupCookie: 'lng',
            lookupLocalStorage: 'lng',
            lookupSessionStorage: 'lng',
        },
        ns: ['translation', 'settings'],
        resources: {
            en: {
                translation: { ...removedTranslations, ...english },
                settings: { settingsTranslationsOld, ...settingsTranslations },
            },
        },
        backend: {
            customHeaders: {
                accept: 'application/json, text/javascript',
                authorization: `Token ${WEBLATE_API_TOKEN}`,
            },
            loadPath: (lng, ns) => {
                if (ns[0] === 'settings') {
                    return 'https://translations.elasticemail.com/api/translations/app-elastic-email/settings/{{lng}}/file/';
                }

                return 'https://translations.elasticemail.com/api/translations/app-elastic-email/email-api-dashboard/{{lng}}/file/';
            },
            crossDomain: true,
            allowMultiLoading: true,
        },
        defaultNS: 'translation',
        fallbackLng,
        fallbackNS: 'translation',
        supportedLngs: availableLanguages,
        debug: DEVMODE === 'DEVELOPMENT',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
        partialBundledLanguages: true,
        returnEmptyString: false,
    });
export { translationInstance };
export default translationInstance;
